import styled from "styled-components";

export const CustomerWrapper = styled.div`
  margin-top: 135px;
  margin-bottom: 0px;
  @media ${(props) => props.theme.tablet} {
    margin-top: 105px;
  }
  @media ${(props) => props.theme.mobile} {
    margin-top: 75px;
  }
`;

export const Path = styled.div`
  font-family: "KBFG Text";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  color: #ffac00;
  margin-bottom: 32px;
  span {
    font-family: "KBFG Text";
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 17px;
    color: #999999;
    :after {
      content: ">";
      margin: 0 14px;
    }
  }

  @media ${(props) => props.theme.laptop} {
    margin-left: 30px;
  }
  @media ${(props) => props.theme.tablet} {
    font-size: 15px;
    line-height: 19px;
    margin-bottom: 25px;
    margin-left: 0px;
    span {
      font-size: 15px;
      line-height: 19px;
    }
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 13px;
    line-height: 19px;
    margin-bottom: 15px;
    span {
      font-size: 13px;
      line-height: 19px;
    }
  }
`;

export const MainTitle = styled.div`
  margin-bottom: 40px;
  h2 {
    font-family: "KBFG Display";
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 62px;
    color: #1a1a1a;
  }
  @media ${(props) => props.theme.laptop} {
    padding-left: 20px;
  }
  @media ${(props) => props.theme.tablet} {
    margin-bottom: 50px;
    padding-left: 0px;
    h2 {
      font-size: 50px;
      line-height: 72px;
    }
  }
  @media ${(props) => props.theme.mobile} {
    margin-bottom: 20px;
    h2 {
      margin-bottom: 25px;
      font-size: 34px;
      line-height: 35px;
    }
  }
`;

export const MainPost = styled.div`
  height: 395px;
  margin-bottom: 85px;
  background-image: url(${(props) => props.theme.image_url}/common/Privacy_bg.png);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  @media ${(props) => props.theme.laptop} {
    background-attachment: scroll;
  }
  @media ${(props) => props.theme.tablet} {
    height: 480px;
    margin-bottom: 100px;
    background-position: center center;
  }
  @media ${(props) => props.theme.mobile} {
    height: 460px;
    margin-bottom: 90px;
    background-position: center center;
  }
`;

export const ContentContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  margin-bottom: 290px;
  p {
    font-family: "KBFG Text";
    font-style: normal;
    font-weight: 300;
    font-size: 17px;
    line-height: 30px;
    color: #000000;
  }
`;
export const PageContent = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 25px;
  }
  p {
    margin-bottom: 25px;
    color: #888;
  }
  a {
    color: #1111;
  }
  table {
    border: 1px solid #eee;
    margin-bottom: 25px;
    th {
      background: #f7f7f7;
    }
    td,
    th {
      padding: 10px;
      border: 1px solid #eee;
      vertical-align: middle;
      line-height: 1.7;
    }
  }
  @media ${(props) => props.theme.mobile} {
    h1,
    h2,
    h3,
    h4,
    h5 {
      line-height: 35px;
      font-size: 21px;
    }
  }
`;
